import { PagedResult, Result, ResourceItem } from "../models/index";
import { ServiceBase } from './ServiceBase';

export class SearchIn {
    keywords: string;

    constructor() {
        this.keywords = '';
    }

    public static fromInput(input: Partial<SearchIn>) {
        var result = new SearchIn();
        result = { ...result, ...input };
        return result;
    }
}

export class InvestorNewsService extends ServiceBase {

    public static async search(filters: SearchIn, pageSize: number, offset: number): Promise<Result<PagedResult<ResourceItem>>> {

        let searchDto = filters;

        let payload = { ...searchDto, pageSize, offset };

        var result = await this.requestJson<PagedResult<ResourceItem>>({
            url: `/api/investornews/list/`,
            method: "POST",
            data: payload
        });

        return result;
    }    
}
